<template>
	<v-card>
		<v-card-title>
			<translate>
				Edit Product
			</translate>
		</v-card-title>
		<v-card-text>
			<v-form>
				<v-row>
					<v-col>
						<v-text-field
							v-model="name"
							:loading="loading"
							variant="outlined"
							density="compact"
							hide-details
							:label="$gettext('Name')"
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-text-field
							v-model="shortname"
							:loading="loading"
							variant="outlined"
							density="compact"
							hide-details
							:label="$gettext('Shortname')"
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-text-field
							v-model="domain"
							:loading="loading"
							readonly
							variant="outlined"
							density="compact"
							hide-details
							:label="$gettext('Domain')"
						/>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-spacer />
			<v-btn
				v-can="'product.update'"
				variant="text"
				color="primary"
				@click="updateDetails"
			>
				Save
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';

export default {
	name: 'ProductEdit',

	props: {
		productId: {
			type: Number,
			required: true
		}
	},

	data () {
		return {
			name: null,
			shortname: null,
			domain: null,
			loading: false
		};
	},

	mounted () {
		this.getDetails();
	},

	methods: {
		/**
		 * Get product details from API
		 */
		getDetails () {
			this.loading = true;
			axios.get(`/api/v0/products?id=${this.productId}`).then(({
				data
			}) => {
				if (data.length) {
					const product = data[0];

					this.name = product.name;
					this.shortname = product.shortname;
					this.domain = product.domain.name;
				}
			}).finally(() => {
				this.loading = false;
			});
		},

		/**
		 * Send product details to API
		 */
		updateDetails () {
			this.loading = true;
			axios.put(`/api/v0/products/${this.productId}`, {
				name: this.name,
				shortname: this.shortname,
				domain: this.domain
			}).finally(() => {
				this.loading = false;
			});
		}
	}
};
</script>

<style scoped>

</style>
